import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Stack,
  Box,
  Button,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

const ReusableCard = ({
  image,
  title,
  date,
  location,
  audience,
  primaryAction,
  secondaryAction,
}) => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "stretch",
        height: "100%", 
        borderRadius: "12px",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
        overflow: "hidden",
        backgroundColor: "#fff",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.12)",
          transform: "translateY(-4px)",
        },
      }}
    >
      {/* Top Image */}
      <Box sx={{ width: "100%", height: 185, overflow: "hidden", p: 2 }}>
        <CardMedia
          component="img"
          image={image}
          alt={title}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            display: "block",
            borderRadius: "8px",
          }}
        />
      </Box>

      {/* Content */}
      <CardContent
        sx={{
          flexGrow: 1, // pushes button to bottom
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "stretch",
          px: 2,
          pt: 0,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            color: "#292929",
            mb: 1,
          }}
        >
          {title}
        </Typography>

        {/* Date & Location */}
        <Stack spacing={0.75} sx={{ mb: 0.5 }}>
          {date && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
              <EventIcon fontSize="small" sx={{ color: "#B8B8B8", flexShrink: 0 }} />
              <Typography
                variant="body2"
                noWrap
                title={date}
                sx={{ color: "#7A7A7A", fontSize: "13px", fontWeight: 500, minWidth: 0 }}
              >
                {date}
              </Typography>
            </Box>
          )}
          {location && (
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.75, minWidth: 0 }}>
              <LocationOnIcon fontSize="small" sx={{ color: "#B8B8B8", flexShrink: 0 }} />
              <Typography
                variant="body2"
                title={location}
                sx={{
                  color: "#7A7A7A",
                  fontSize: "13px",
                  fontWeight: 500,
                  lineHeight: 1.45,
                  mt: "1px",
                  minWidth: 0,
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                  overflow: "hidden",
                  wordBreak: "break-word",
                }}
              >
                {location}
              </Typography>
            </Box>
          )}
        </Stack>

        {/* Audience */}
        {audience && (
          <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            <PeopleAltIcon fontSize="small" sx={{ color: "#B8B8B8", mr: 0.5 }} />
            <Typography
              variant="body2"
              sx={{
                color: "#7A7A7A",
                fontSize: "13px",
                mt: 0.5,
              }}
            >
              <strong>Audience:</strong> {audience}
            </Typography>
          </Box>
        )}
      </CardContent>

      {/* Bottom Button */}
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="stretch"
        sx={{
          px: 2,
          pb: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={secondaryAction?.onClick}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            backgroundColor: "#F14950",
            color: "#fff",
            boxShadow: "none",
            px: 3,
            alignSelf: "flex-end",
            "&:hover": {
              backgroundColor: "#b02a2a",
              boxShadow: "none",
            },
          }}
        >
          {secondaryAction?.label || "View"}
        </Button>
      </Stack>
    </Card>
  );
};

export default ReusableCard;
